import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { toastr } from "react-redux-toastr";
import Layout from "components/Layout";
import { Nav, Tab, FormGroup, FormControl, Dropdown } from "react-bootstrap";
import {
	FiPlus,
	FiExternalLink,
	FiMoreHorizontal,
	FiDownload,
	FiUpload,
	FiTool,
	FiSettings,
	FiChevronLeft,
	FiChevronRight,
} from "react-icons/fi";
import Moment from "react-moment";
import moment from "moment";
import Loading from "components/Loading";
import AbsenceCalendar from "components/Absences/AbsenceCalendar";
import MyAbsences from "components/Absences";
import AbsenceEditModal from "components/Absences/AbsenceEditModal";
import AbsenceSidebar from "components/Absences/AbsenceSidebar";
import AbsenceViewEdit from "components/Absences/AbsenceViewEditModal";
import PlanViewEditModal from "components/PlanViews/PlanViewEditModal";
import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import * as plansActions from "actions/plansActions";
import * as rulesActions from "actions/rulesActions";
import * as workflowsActions from "actions/workflowsActions";
import * as employeesActions from "actions/employeesActions";
import * as shiftsActions from "actions/shiftsActions";
import {
	workflowsService,
	appService,
	dashboardsService,
	accountsService,
	groupsService,
	employeesService,
} from "services";
import { wfStatus } from "services/workflowsService";
import { shiftTypeQuery } from "services/shiftsService";
import TeamAbsences from "components/Absences/TeamAbsences";
import Modal from "components/Modal";
import { isAdmin, isSupervisor } from "utils/utils";
import { helpUrls } from "utils/helpUrls";
import HelpBanner from "components/HelpBanner";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";

class Absences extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewAbsenceModal = this.openNewAbsenceModal.bind(this);
		this.openEditAbsenceModal = this.openEditAbsenceModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.handleCancelRequest = this.handleCancelRequest.bind(this);
		this.handleReopenRequest = this.handleReopenRequest.bind(this);
		this.openEditAbsenceViewModal = this.openEditAbsenceViewModal.bind(this);
		this.openNewPlanViewModal = this.openNewPlanViewModal.bind(this);
		this.updateAbsenceHeader = this.updateAbsenceHeader.bind(this);

		const today = new Date();
		const year = today.getFullYear();

		this.headerEmployeeFetchOptions = { enabled: true };

		this.state = {
			year,
			search_employee: this.props.user.id,
			search_employee_name: this.props.user.name,
			/** Empleado visto en cabecera (objeto API) cuando no está en select_employees del reducer */
			absenceSidebarEmployee: null,
			isSubmit: false,
			show_worked_holidays: false,
			worked_holidays: [],
			updateIndicator: 0,
			vacationData: null,
			customCounters: null,
			showNewAbsenceModal: false,

			// Team Absences State
			team_year: today.getFullYear(),
			team_month: today.getMonth(), // 0-11
			team_group_filter: "",
			groups: [],
			team_employees: [],
			activeTab: "calendar",
			teamRefreshKey: 0,
		};
	}

	async componentDidMount() {
		// Leer query parameter 'employee' de la URL
		const queryParams = new URLSearchParams(window.location.search);
		const employeeFromQuery = queryParams.get("employee");
		let loadedGroups = [];

		if (isAdmin() || isSupervisor()) {
			const groupsResponse = await groupsService.getAll({ variant: "select" });
			loadedGroups = groupsResponse.ok ? groupsResponse.data : [];
			if (loadedGroups.length > 0) {
				this.setState({ groups: loadedGroups });
			}

			if (employeeFromQuery) {
				const employeeId = parseInt(employeeFromQuery, 10);
				if (!Number.isNaN(employeeId)) {
					try {
						const res = await employeesService.getById(employeeId);
						if (res.ok && res.id) {
							this.setState({
								search_employee: res.id,
								search_employee_name: `${res.name} ${res.surname || ""}`.trim(),
								absenceSidebarEmployee: res,
							});
						} else {
							console.warn("Empleado no encontrado o sin permisos:", employeeId);
						}
					} catch (e) {
						console.warn("Empleado no encontrado o sin permisos:", employeeId, e);
					}
				}
			}
		}

		// Cargar datos DESPUÉS de haber aplicado el query parameter
		this.getData({ groups: loadedGroups });
	}

	async componentDidUpdate(prevProps, prevState) {
		if (prevState.updateIndicator !== this.state.updateIndicator) {
			this.loadSidebarData();
		}
		// Reload sidebar data (counters) if the absences list has changed
		if (prevProps.employee_absences !== this.props.employee_absences) {
			this.loadSidebarData();
		}
		if (
			this.state.activeTab === "team" &&
			prevState.groups !== this.state.groups &&
			this.state.groups.length > 0 &&
			!this.state.team_group_filter
		) {
			this.loadTeamEmployees();
		}
	}

	async getData(options = {}) {
		this.setState({ loading: true }); // loading

		const { activeTab, search_employee, year } = this.state;
		var contract_absence_shifts = true;

		const promises = [
			this.props.getSelectableEmployees({ enabled: true }),
			this.props.getAbsenceShifts({
				shift_type: shiftTypeQuery.absence,
				contract_only: contract_absence_shifts,
			}),
			this.props.getPlanViews(true),
		];

		if (activeTab === "calendar") {
			promises.push(
				this.props.getEmployeeAbsenceCalendar(search_employee, year)
			);
		} else if (activeTab === "mine") {
			promises.push(this.props.getEmployeeAbsences(search_employee));
		} else if (activeTab === "team") {
			this.setState((prevState) => ({
				teamRefreshKey: prevState.teamRefreshKey + 1,
			}));
			promises.push(this.loadTeamEmployees(options.groups));
		}

		await Promise.all(promises);

		const worked_holidays = this.props.employee_absence_calendar.filter((o) => {
			return o.worked_holiday === true;
		});

		this.setState({
			loading: false,
			worked_holidays,
		});

		this.loadSidebarData();
	}

	loadTeamEmployees = async (groupsOverride) => {
		const { team_group_filter, groups: stateGroups } = this.state;
		const groups = groupsOverride || stateGroups;

		if (team_group_filter) {
			const response = await employeesService.getAll({
				group_id: team_group_filter,
				enabled: true,
				variant: "detailed",
				page_size: 2000,
			});
			if (response.ok) {
				this.setState({ team_employees: response.data || [] });
			}
			return;
		}

		const groupIds = (groups || []).map((group) => group.id).filter(Boolean);
		if (groupIds.length === 0) {
			this.setState({ team_employees: [] });
			return;
		}

		const responses = await Promise.all(
			groupIds.map((groupId) =>
				employeesService.getAll({
					group_id: groupId,
					enabled: true,
					variant: "detailed",
					page_size: 2000,
				}).then((response) => ({ groupId, response }))
			)
		);

		const merged = [];
		const mergedById = new Map();
		responses.forEach(({ groupId, response }) => {
			if (!response.ok || !Array.isArray(response.data)) return;
			response.data.forEach((employee) => {
				const key = String(employee.id);
				const groupAssignment = {
					id: groupId,
					start_day: employee.employee_with_group?.start_day,
					end_day: employee.employee_with_group?.end_day,
				};

				if (mergedById.has(key)) {
					const existing = mergedById.get(key);
					existing.groups.push(groupAssignment);
					return;
				}

				const enrichedEmployee = {
					...employee,
					groups: [groupAssignment],
				};
				mergedById.set(key, enrichedEmployee);
				merged.push(enrichedEmployee);
			});
		});

		this.setState({ team_employees: merged });
	};

	loadSidebarData = async () => {
		const { search_employee, year } = this.state;

		// Load vacation summary
		const vacationData = await dashboardsService.getEmployeeVacationSummary(
			search_employee,
			year
		);

		// Load custom counters
		const start_from = `${year}-01-01`;
		const end_to = `${year}-12-31`;

		const response = await accountsService.getAccountAssignments({
			employee_id: search_employee,
			start: start_from,
			end: end_to,
			my_absences: true,
		});

		let customCounters = [];
		if (response.ok) {
			customCounters = response.data?.[0]?.counters || [];
		}

		this.setState({
			vacationData,
			customCounters,
		});
	};

	handleHeaderEmployeeChange = (idStr, emp) => {
		if (!idStr) return;
		const id = Number(idStr);
		const name = emp
			? `${emp.name} ${emp.surname || ""}`.trim()
			: this.state.search_employee_name;
		this.setState(
			{
				search_employee: id,
				search_employee_name: name,
				absenceSidebarEmployee: emp || null,
			},
			async () => {
				await this.props.getEmployeeAbsenceCalendar(id, this.state.year);
				if (isAdmin() || isSupervisor()) {
					await this.props.getEmployeeAbsences(id);
				}
				this.loadSidebarData();
			}
		);
	};

	openEditAbsenceViewModal() {
		const { plan_views } = this.props;
		// console.log(plan_views);
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.configView"),
				style: { width: "400px" },
				content: (
					<AbsenceViewEdit
						handleClose={this.closeModal}
						updateAbsenceHeader={this.updateAbsenceHeader}
						plan_views={plan_views}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	async openNewPlanViewModal() {
		await Promise.all([
			this.props.getAccounts(),
			this.props.getRules(),
			this.props.getPlanViewScopes(),
		]);

		this.props.showModal(
			{
				open: true,
				title: this.props.t("planViews.newView"),
				style: { width: "600px" },
				content: <PlanViewEditModal handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	updateAbsenceHeader = () => {
		this.setState((prevState) => ({
			updateIndicator: prevState.updateIndicator + 1, // Incrementa el indicador para forzar la actualización
		}));
	};

	toggleWorkedHolidays() {
		this.setState((prevState) => ({
			show_worked_holidays: !prevState.show_worked_holidays,
		}));
	}

	handleChangeSearch = (event) => {
		const target_id = event.target.id;
		var search_employee_name = this.state.search_employee_name;

		if (target_id === "search_employee") {
			search_employee_name =
				event.target.options[event.target.selectedIndex].text;
		}
		// console.log(event.target.options[event.target.selectedIndex].text)

		this.setState(
			{
				[target_id]: event.target.value,
				search_employee_name,
			},
			async () => {
				await this.props.getEmployeeAbsenceCalendar(
					this.state.search_employee,
					this.state.year
				);

				if ((isAdmin() || isSupervisor()) && target_id === "search_employee") {
					await this.props.getEmployeeAbsences(this.state.search_employee);
				}
				this.loadSidebarData();
			}
		);
	};

	closeModal() {
		this.props.hideModal();
	}

	openNewAbsenceModal() {
		this.setState({ showNewAbsenceModal: true });
	}

	closeNewAbsenceModal() {
		this.setState({ showNewAbsenceModal: false });
	}

	openEditAbsenceModal(absence, disabled) {
		this.props.showModal(
			{
				open: true,
				title: disabled ? this.props.t("absences.viewAbsence") : this.props.t("absences.editAbsence"),
				style: { width: "430px" },
				content: (
					<AbsenceEditModal
						absence={absence}
						disabled={disabled}
						year={this.state.year}
						viewedEmployeeId={this.state.search_employee}
						activeTab={this.state.activeTab}
						refreshData={() => this.getData()}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || this.props.t("common.error"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	handleCancelRequest(absence) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.cancelAbsence"),
				style: { width: "350px" },
				message:
					this.props.t("absences.cancelAbsenceConfirm"),
				deleteAction: () => this.confirmCancelRequest(absence),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	confirmCancelRequest = async (absence) => {
		absence.status = wfStatus.canceled;
		absence.shift_id = absence.shift.id;

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(absence);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

				this.props.getEmployeeAbsences(this.state.search_employee);
				this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					this.openAlertModal(textError, this.props.t("absences.errorCancelling"));
				} else {
					this.openAlertModal(this.props.t("common.errorGeneric"), this.props.t("absences.errorCancelling"));
				}
			}
		}
	};

	// reabrir ausencia
	handleReopenRequest(absence) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.reopenAbsence"),
				style: { width: "350px" },
				message: this.props.t("absences.reopenAbsenceConfirm"),
				deleteAction: () => this.confirmReopenRequest(absence),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	confirmReopenRequest = async (absence) => {
		absence.status = wfStatus.pending;
		absence.shift_id = absence.shift.id;
		this.openEditAbsenceModal(absence, false);

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(absence);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

				this.props.getEmployeeAbsences(this.state.search_employee);
				this.openEditAbsenceModal(absence, false);
				// this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					console.log(textError);
					toastr.warning(this.props.t("absences.reopenedWithErrors"), textError);
				}
			}
		}
	};

	// exportar

	openExportAbsencesModal(token) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.exportAbsences"),
				style: { width: "400px" },
				confirmText: this.props.t("common.download"),
				loadingText: this.props.t("common.downloading"),
				message:
					this.props.t("absences.exportSuccess"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, "ausencias.xlsx");
				},
			},
			"confirm"
		);
	}

	async handleExportAbsences(workflow_status) {
		// TODO const { start_to, start_from, employee_id } = this.state;

		// Aprobado,Denegado (Gestionadas)  / Pendiente (Pendientes)
		const token = await workflowsService.exportWorkflows({
			workflow_status,
		});

		if (token.ok) {
			this.openExportAbsencesModal(token.access_token);
		} else {
			this.openAlertModal(
				this.props.t("absences.errorExporting"),
				this.props.t("absences.errorExportingTitle")
			);
		}
	}

	async downloadExport(token, filename) {
		const response = await appService.getExported(token);
		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = filename;
		a.click();

		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	handleTeamFilterChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value }, () => {
			if (name === "team_group_filter") {
				this.loadTeamEmployees();
			}
		});
	};

	handleTeamEmployeeSelect = (employee) => {
		this.setState(
			{
				search_employee: employee.id,
				search_employee_name: employee.name + " " + (employee.surname || ""),
				year: this.state.team_year, // Sync year
				activeTab: "calendar",
			},
			() => {
				// Trigger data reload for the new employee
				this.getData();
			}
		);
	};

	handleTabSelect = (k) => {
		if (k !== this.state.activeTab) {
			this.setState({ activeTab: k }, () => {
				this.getData();
			});
		}
	};

	getContent = () => {
		if (this.props.loading && !this.props.employee_absences) {
			return <Loading />;
		}

		if (!this.props.employee_absences) {
			return this.props.t("absences.errorLoading");
		}

		let first_steps = "";

		if (
			this.props.employee_absences.length == 0 &&
			this.props.pending_absences.length === 0 &&
			this.props.managed_absences.length === 0
		) {
			const step_text =
				isAdmin() || isSupervisor()
					? this.props.t("absences.firstStepsAdmin")
					: this.props.t("absences.firstStepsEmployee");

			first_steps = (
				<div className="first-steps">
					<FiExternalLink className="icono-pasos" />
					<h3 className="title2">{this.props.t("absences.firstStepsTitle")}</h3>

					<p>
						{step_text} {this.props.t("absences.firstStepsLink")}{" "}
						<a className="alink" target="_blank" href={helpUrls.absence}>
							{helpUrls.absence}
						</a>
					</p>
				</div>
			);
		}

		const { worked_holidays, show_worked_holidays, search_employee } =
			this.state;

		return (
			<>
				{/* {first_steps} */}
				<div className="employee-detail-container">
					{this.state.activeTab !== "team" && (
						<AbsenceSidebar
							employee={
								this.state.absenceSidebarEmployee ||
								this.props.select_employees.find(
									(e) => e.id == search_employee
								) ||
								this.props.user
							}
							vacationData={this.state.vacationData}
							customCounters={this.state.customCounters}
							history={this.props.history}
						/>
					)}

					<div className="employee-main-content">
						<Tab.Content className="employee-tab-content">
							<Tab.Pane eventKey="calendar" style={{ padding: "0" }}>
								<AbsenceCalendar />
								<div className="box box-total">
									<div className="box-total-header">
										<h4>
											{this.props.t("absences.totalWorkedHolidays")}{" "}
											<strong>{worked_holidays.length}</strong>
										</h4>
										<button
											type="button"
											className="button-link"
											onClick={() => this.toggleWorkedHolidays()}
										>
											{show_worked_holidays
												? this.props.t("absences.hideDetail")
												: this.props.t("absences.showDetail")}
										</button>
									</div>

									{show_worked_holidays && (
										<ul className="list-worked-holidays">
											{worked_holidays.map((item, i) => {
												return (
													<li key={i}>
														<span
															className="tag-day-type"
															style={{
																backgroundColor:
																	item.day_type.color && item.day_type.color,
															}}
														>
															{item.day_type.name}
														</span>
														<Moment format="DD/MM/YY">{item.day}</Moment>
														<span>{item.comments}</span>
													</li>
												);
											})}
										</ul>
									)}
								</div>
							</Tab.Pane>
							<Tab.Pane eventKey="mine" style={{ padding: "0" }}>
								<MyAbsences
									handleCancelRequest={this.handleCancelRequest}
									handleReopenRequest={this.handleReopenRequest}
									openEditAbsenceModal={this.openEditAbsenceModal}
								/>
							</Tab.Pane>
							<Tab.Pane eventKey="team" style={{ padding: "0" }}>
								<div
									className="box-filters"
									style={{ marginBottom: "20px", display: "flex", gap: "15px" }}
								>
									{this.state.groups.length > 1 && (
										<FormGroup
											controlId="team_group_filter"
											style={{ minWidth: "200px", marginBottom: 0 }}
										>
											<FormControl
												as="select"
												name="team_group_filter"
												value={this.state.team_group_filter}
												onChange={this.handleTeamFilterChange}
											>
												<option value="">{this.props.t("absences.allGroups")}</option>
												{this.state.groups.map((g) => (
													<option key={g.id} value={g.id}>
														{g.name}
													</option>
												))}
											</FormControl>
										</FormGroup>
									)}

									<div
										style={{
											display: "flex",
											alignItems: "center",
											gap: "16px",
											padding: "5px 10px",
										}}
									>
										<div
											style={{ cursor: "pointer" }}
											onClick={() => {
												let newMonth = this.state.team_month - 1;
												let newYear = this.state.team_year;
												if (newMonth < 0) {
													newMonth = 11;
													newYear--;
												}
												this.setState({
													team_month: newMonth,
													team_year: newYear,
												});
											}}
										>
											<FiChevronLeft size={24} color="#101828" />
										</div>
										<span
											style={{
												fontWeight: "500",
												fontSize: "14px",
												textAlign: "center",
												color: "#101828",
												textTransform: "capitalize",
											}}
										>
											{moment()
												.month(this.state.team_month)
												.year(this.state.team_year)
												.format("MMMM YYYY")}
										</span>
										<div
											style={{ cursor: "pointer" }}
											onClick={() => {
												let newMonth = this.state.team_month + 1;
												let newYear = this.state.team_year;
												if (newMonth > 11) {
													newMonth = 0;
													newYear++;
												}
												this.setState({
													team_month: newMonth,
													team_year: newYear,
												});
											}}
										>
											<FiChevronRight size={24} color="#101828" />
										</div>
									</div>
								</div>

								<TeamAbsences
									year={this.state.team_year}
									month={this.state.team_month + 1}
									group_id={this.state.team_group_filter}
									groupScopedList
									employees={this.state.team_employees}
									onEmployeeSelect={this.handleTeamEmployeeSelect}
									openEditAbsenceModal={this.openEditAbsenceModal}
									handleCancelRequest={this.handleCancelRequest}
									handleReopenRequest={this.handleReopenRequest}
									refreshKey={this.state.teamRefreshKey}
								/>
							</Tab.Pane>
						</Tab.Content>
					</div>
				</div>
			</>
		);
	};

	render() {
		const currentYear = new Date().getFullYear();
		const range = (start, stop, step) =>
			Array.from(
				{ length: (stop - start) / step + 1 },
				(_, i) => start + i * step
			);

		const optionYearList = range(currentYear + 1, 2020, -1).map((item, i) => {
			return (
				<option key={i} value={item}>
					{item}
				</option>
			);
		}, this);

		return (
			<>
				{/* Modal de nueva ausencia — usa SimpleModal propio con layout bipartito */}
				{this.state.showNewAbsenceModal && (
					<AbsenceEditModal
						year={this.state.year}
						viewedEmployeeId={this.state.search_employee}
						activeTab={this.state.activeTab}
						refreshData={() => this.getData()}
						handleClose={() => this.closeNewAbsenceModal()}
					/>
				)}
				<Layout className="page-absences page-employee" context="absences">
					<div
						className={`heading${
							this.state.activeTab === "team" ? " heading-team" : ""
						}`}
					>
						<h1 className="title">
							{isAdmin() || isSupervisor() ? this.props.t("absences.title") : this.props.t("absences.myAbsences")}
						</h1>

						<div className="heading-help-banner hidden-sm">
							<HelpBanner
								title={this.props.t("common.needHelp")}
								text={this.props.t("common.helpText")}
								linkText={this.props.t("common.moreInfo")}
								linkHref="https://help.plain.ninja/es/collections/2144738-gestion-de-ausencias-y-vacaciones"
							/>
						</div>

						<div
							className={`heading-actions${
								this.state.activeTab === "team"
									? " heading-actions-team"
									: ""
							}`}
						>
							{(isAdmin() || isSupervisor()) &&
								this.state.activeTab !== "team" && (
									<EmployeeSelectSearch
										className="form-select-user mr10"
										controlId="search_employee"
										multiple={false}
										allowClear={false}
										value={String(this.state.search_employee)}
										onChange={this.handleHeaderEmployeeChange}
										fetchOptions={this.headerEmployeeFetchOptions}
										placeholder={this.props.t("common.searchEmployee")}
										knownEmployee={
											this.state.absenceSidebarEmployee ||
											(Number(this.state.search_employee) ===
											Number(this.props.user.id)
												? this.props.user
												: null)
										}
										pinnedShortcut={
											Number(this.state.search_employee) !==
											Number(this.props.user.id)
												? {
														id: this.props.user.id,
														label: this.props.t("absences.myAbsences"),
														employee: this.props.user,
													}
												: null
										}
									/>
								)}

							<FormGroup
								className={`form-group form-group-year${
									this.state.activeTab === "team" ? " hidden" : ""
								}`}
								controlId="year"
							>
								<FormControl
									type="text"
									value={this.state.year}
									onChange={this.handleChangeSearch}
									as="select"
								>
									{optionYearList}
								</FormControl>
							</FormGroup>

							<button
								type="button"
								title={this.props.t("absences.createAbsence")}
								onClick={this.openNewAbsenceModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
							{(isAdmin() || isSupervisor()) && (
								<Dropdown>
									<Dropdown.Toggle variant="action">
										<FiMoreHorizontal />
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Dropdown.Item
											as="button"
											onClick={() =>
												this.props.history.push("/absences/import")
											}
										>
											<FiDownload /> {this.props.t("absences.importAbsences")}
										</Dropdown.Item>

										<Dropdown.Item
											as="button"
											onClick={() => this.handleExportAbsences(wfStatus.pending)}
										>
											<FiUpload className="dropdown-icon" /> {this.props.t("absences.exportPending")}
										</Dropdown.Item>

										<Dropdown.Item
											as="button"
											onClick={() =>
												this.handleExportAbsences(`${wfStatus.approved},${wfStatus.denied}`)
											}
										>
											<FiUpload className="dropdown-icon" /> {this.props.t("absences.exportManaged")}
										</Dropdown.Item>

										{this.props.plan_views.length > 1 && (
											<Dropdown.Item
												as="button"
												onClick={() => this.openEditAbsenceViewModal()}
											>
												<FiTool className="dropdown-icon" /> {this.props.t("absences.configView")}
											</Dropdown.Item>
										)}

										<Dropdown.Item
											as="button"
											onClick={() => this.props.history.push("/plan-views")}
										>
											<FiSettings className="dropdown-icon" /> {this.props.t("planViews.configureViews")}
										</Dropdown.Item>

										<Dropdown.Item
											as="button"
											onClick={this.openNewPlanViewModal}
										>
											<FiPlus className="dropdown-icon" /> {this.props.t("planViews.newView")}
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							)}
						</div>
					</div>

					<Tab.Container
						activeKey={this.state.activeTab}
						onSelect={this.handleTabSelect}
					>
						<Nav
							variant="tabs"
							className="employee-tabs"
							style={{ marginBottom: "20px", paddingLeft: "0" }}
						>
							<Nav.Item>
								<Nav.Link eventKey="calendar">{this.props.t("absences.calendarTab")}</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="mine">
									{this.props.user.id !== this.state.search_employee * 1
										? this.props.t("absences.absencesOf", { name: this.state.search_employee_name })
										: this.props.t("absences.myAbsences")}
								</Nav.Link>
							</Nav.Item>
							{(isAdmin() || isSupervisor()) && (
								<Nav.Item>
									<Nav.Link eventKey="team">{this.props.t("absences.teamTab")}</Nav.Link>
								</Nav.Item>
							)}
						</Nav>

						{this.getContent()}
					</Tab.Container>
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		...reducers.plansReducer,
		user: reducers.authReducer.user,
		loading: reducers.workflowsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getEmployeeAbsences: (employee_id) =>
		dispatch(employeesActions.getEmployeeAbsences(employee_id)),
	getEmployeeAbsenceCalendar: (employee_id, year) =>
		dispatch(employeesActions.getEmployeeAbsenceCalendar(employee_id, year)),
	getPendingAbsences: (options) =>
		dispatch(workflowsActions.getPendingAbsences(options)),
	getManagedAbsences: (options) =>
		dispatch(workflowsActions.getManagedAbsences(options)),
	getAbsenceShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
	getSelectableEmployees: (options) =>
		dispatch(employeesActions.getSelectableEmployees(options)),
	getPlanViews: (includeAll) => dispatch(plansActions.getPlanViews(includeAll)),
	getPlanViewScopes: () => dispatch(plansActions.getPlanViewScopes()),
	getAccounts: () => dispatch(rulesActions.getAccounts()),
	getRules: () => dispatch(rulesActions.getCalculatedRules()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Absences));
